function FormButton() {
	const button = document.querySelector('.a-button');
	const popUp = document.querySelector('.pum-theme-lightbox');
	const clickedDate = localStorage.getItem('popup-clicked');

	if(button) {
		const today = button.getAttribute('data-today');

		if (clickedDate && clickedDate == today) {
			document.body.classList.add('form-close');
		}

		if (!popUp) {
			button.classList.add('no-popup');
		}

		button.addEventListener('click', function() {
			document.body.classList.toggle('form-close');
			localStorage.setItem('popup-clicked', today);
		});
	}
}

export default FormButton;